const images = {
    getImagePath(string) {
        try{
            return require(`../assets/images/${string}`);
        }catch{
            return require(`../assets/images/kong.png`);
        }
    },
}
export default images